import Api from '@/services/Api'

export default {
  getFabrics (token) {
    return Api().get('fabrics')
  },

  getFabric (id) {
    return Api().get('fabric/' + id)
  },

  getFabricsByTag (tag) {
    return Api().get('fabrics/' + tag)
  },

  getFabricsByGroup (id) {
    return Api().get('fabricsByGroup/' + id)
  },

  createFabric (fabric) {
    return Api().post('fabrics', fabric)
  },

  updateFabric (params) {
    return Api().put('fabric/' + params._id, params)
  },

  deleteFabric (fabricID) {
    return Api().delete('fabric/' + fabricID)
  }
}



// WEBPACK FOOTER //
// ./src/services/FabricService.js